import vueInstance from "../main";

export const dateTypes = Object.freeze({
  DATE_DELEGATION_TRIP: 1,
  DATE_DELEGATION_SENT: 2,
  DATE_DELEGATION_ACCEPT: 3,
  DATE_DELEGATION_SETTLE: 4
});

export const dateSpanTypes = Object.freeze({
  DATE_SPAN_TYPE_CUSTOM: 1,
  DATE_SPAN_TYPE_MONTHLY: 2,
  DATE_SPAN_TYPE_QUARTERLY: 3,
  DATE_SPAN_TYPE_YEARLY: 4
});

export const reportTypes = Object.freeze({
  TYPE_DETAILED: 1,
  TYPE_SUMMARY: 2,
  TYPE_SUMMARY_EXCHANGE: 3,
  TYPE_INVOICE_EXCHANGE: 4,
  TYPE_BUDGET: 5,
  TYPE_INVOICE_INTERNAL: 6
});

export const reportTypeNames = function() {
  return [
    //  { text: "Raport szczegółowy", value: reportTypes.TYPE_DETAILED },
    {
      text: vueInstance.$t("report.reportTypes.summaryReport"),
      value: reportTypes.TYPE_SUMMARY,
      exchange: false,
      fileFormats: ["PDF", "ZIP", "PDF-MERGED", "CSV", "XLS"]
    },
    {
      text: vueInstance.$t("report.reportTypes.summaryExchangeReport"),
      value: reportTypes.TYPE_SUMMARY_EXCHANGE,
      exchange: true,
      fileFormats: ["PDF", "PDF-MERGED", "ZIP"]
    },
    {
      text: vueInstance.$t("report.reportTypes.invoiceInternalReport"),
      value: reportTypes.TYPE_INVOICE_INTERNAL,
      exchange: false,
      fileFormats: ["PDF-MERGED"]
    },
    {
      text: vueInstance.$t("report.reportTypes.invoiceExchangeReport"),
      value: reportTypes.TYPE_INVOICE_EXCHANGE,
      exchange: true,
      fileFormats: ["PDF", "PDF-MERGED", "ZIP"]
    },
    {
      text: vueInstance.$t("report.reportTypes.budgetReport"),
      value: reportTypes.TYPE_BUDGET,
      exchange: false,
      fileFormats: ["XLS"]
    }
  ].sort((a, b) => (a.text > b.text ? 1 : -1));
};

export const dateTypeNames = function() {
  return [
    {
      text: vueInstance.$t("report.dateTypeNames.trip"),
      value: dateTypes.DATE_DELEGATION_TRIP
    },
    {
      text: vueInstance.$t("report.dateTypeNames.sent"),
      value: dateTypes.DATE_DELEGATION_SENT
    },
    {
      text: vueInstance.$t("report.dateTypeNames.accept"),
      value: dateTypes.DATE_DELEGATION_ACCEPT
    },
    {
      text: vueInstance.$t("report.dateTypeNames.settle"),
      value: dateTypes.DATE_DELEGATION_SETTLE
    }
  ].sort((a, b) => (a.text > b.text ? 1 : -1));
};

export const reportFileFormats = function() {
  return [
    { text: "PDF", value: "PDF" },
    { text: "PDF Merged", value: "PDF-MERGED" },
    /* { text: "CSV", value: "CSV" },*/
    { text: vueInstance.$t("report.zipIncludesAttachmentsAndSettlements"), value: "ZIP" },
    { text: "XLS", value: "XLS" },
    { text: "CSV", value: "CSV" }
  ].sort((a, b) => (a.text > b.text ? 1 : -1));
};
